import React, { useState, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { formatDateAsQuery } from 'src/helpers/UtilityHelper';
import StyleConfig from 'src/constants/StyleConfig';
import Button, { LinkButton } from 'src/components/atoms/button/Button';
import InlineDatePicker from 'src/components/atoms/datepicker/InlineDatePicker';

interface Props {
  selectableDays: string[];
  nextBaseUrl?: string;
  onNext?: (date: Date) => void;
  onDateChange?: (date: Date) => void;
  onMonthChange?: (date: Date) => void;
}

const DatePickerForm = ({ ...props }: Props) => {
  const { selectableDays, nextBaseUrl, onNext, onDateChange, onMonthChange } = props;

  const [date, setDate] = useState(new Date());

  const wrapOnNext = useCallback(() => {
    if (onNext) {
      onNext(date);
    }
  }, [onNext, date]);

  const wrapOnDateChange = useCallback(
    (d: Date) => {
      if (onDateChange) {
        onDateChange(d);
      }
      setDate(d);
    },
    [onDateChange, setDate],
  );

  const wrapOnMonthChange = useCallback(
    (d: Date) => {
      if (onMonthChange) {
        onMonthChange(d);
      }
    },
    [onMonthChange],
  );

  const buttonUrl = useMemo(() => `${nextBaseUrl}/${formatDateAsQuery(date)}`, [nextBaseUrl, date]);

  return (
    <Styled>
      <div>
        <InlineDatePicker
          date={date}
          onDateChange={(date) => wrapOnDateChange(date)}
          onMonthChange={(date) => wrapOnMonthChange(date)}
          selectableDays={selectableDays}
        />
      </div>
      <div className="buttonWrapper">
        {onNext && (
          <Button isDisabled={false} clickEvent={wrapOnNext} text={'この日付を確認する'} />
        )}
        {nextBaseUrl && (
          <LinkButton isDisabled={false} url={buttonUrl} text={'この日付を確認する'} />
        )}
      </div>
    </Styled>
  );
};

DatePickerForm.defaultProps = {
  onNext: undefined,
  nextBaseUrl: '',
};

const Styled = styled.div`
  box-sizing: border-box;
  > .buttonWrapper {
    margin: ${StyleConfig.HELPER.M24} 0;
  }
`;

export default DatePickerForm;
